import { Component, effect, inject, OnInit, Renderer2, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ApplicationStore } from '@data-access/user/stores/application.store';

@Component({
  selector: 'app-theme-picker',
  styles: `

    .switch {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 34px;
      margin-right: 12px;
    }

    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: var(--mat-sys-primary);
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 34px;
      border: 2px solid var(--mat-sys-primary);
    }

    .slider:before {
      position: absolute;
      content: '';
      height: 26px;
      width: 26px;
      bottom: 2px;
      background-color: var(--grey-100);
      -webkit-transition: 0.2s;
      transition: 0.2s;
      border-radius: 50%;
      background-image: url('/assets/images/moon.svg');
      //background-size: 22px 22px;
      background-repeat: no-repeat;
      background-position: center;
      //filter: contrast(0.5);
    }

    input:checked + .slider {
      background-color: var(--grey-30);
      border-color: var(--grey-30);
    }

    //input:focus + .slider {
    //  box-shadow: 0 0 1px #0f2;
    //}

    input:checked + .slider:before {
      transform: translateX(26px);
      background-image: url('/assets/images/sun.svg');
    }

  `,
  imports: [MatButtonModule, MatTooltipModule, MatIconModule],
  template: `
    <label class="switch">
      <input type="checkbox" id="theme-toggle" [checked]="mode() !== 'dark'" (click)="changeMode()"/>
      <span class="slider"></span>
    </label>
  `,
})
export class ThemeTogglerComponent implements OnInit {

  mode = signal('dark');
  private readonly appStore = inject(ApplicationStore);

  private renderer = inject(Renderer2);

  /**
   *
   */
  constructor() {
    effect(() => {
      if (this.mode() == 'dark') {
        this.renderer.setStyle(document.documentElement, 'color-scheme', 'dark');
      } else {
        this.renderer.setStyle(document.documentElement, 'color-scheme', 'light');
      }
    });

  }

  ngOnInit(): void {
    const currentTheme = this.getStoredThemeName() ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    if (currentTheme) {
      this.mode.set(currentTheme);
    }
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
      // const newColorScheme = event.matches ? "dark" : "light";
      if (event.matches) {
        this.mode.set('dark');
      } else {
        this.mode.set('light');
      }
    });

  }

  changeMode() {
    if (this.mode() == 'dark')
      this.mode.set('light');
    else
      this.mode.set('dark');
    this.storeTheme(this.mode());
  }

  storeTheme(theme: string) {

      this.appStore.setTheme(theme);

  }

  getStoredThemeName(): string | null {
    try {
      return this.appStore.theme() || null;
    } catch {
      return null;
    }
  }
}
